export const AUTH_SESSION_ENDED_EVENT = 'cto-auth-session-ended'

export type AuthSessionEndReason = 'logout' | 'session-expired'

export function notifyAuthSessionEnded(reason: AuthSessionEndReason) {
  if (typeof window === 'undefined') return

  window.dispatchEvent(
    new CustomEvent(AUTH_SESSION_ENDED_EVENT, {
      detail: { reason },
    })
  )
}
